import _Fab from "@material-ui/core/esm/Fab";
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import { v4 } from 'uuid';
import UpwardIcon from '@material-ui/icons/ArrowUpward';
import { makeStyles } from '@material-ui/core/styles';
import { BUTTON } from './design-attachment-upload-styles';
import classes from './design-note.scss';
const useStyles = makeStyles(() => ({
  button: _objectSpread({}, BUTTON),
  icon: {
    fontSize: '15px'
  }
}));
export default function DesignAttachmentsForm({
  onFileAdd,
  className,
  tabIndex = 0
}) {
  // @ts-ignore
  const myStyles = useStyles();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", {
    className: classes.hidden,
    type: "file",
    multiple: false,
    value: "",
    "aria-label": "Upload",
    onChange: e => {
      // @todo. auto generated. fix this error
      // @ts-ignore
      const file = e.target.files[0];
      // @ts-ignore
      file.id = v4();
      onFileAdd(file);
    },
    id: "file_upload",
    name: "file_upload",
    tabIndex: tabIndex
  }), /*#__PURE__*/React.createElement("label", {
    className: classnames(classes.uploadButton, className),
    htmlFor: "file_upload"
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.uploadText
  }, "Upload"), /*#__PURE__*/React.createElement(_Fab, {
    component: "div",
    className: myStyles.button,
    color: "secondary",
    tabIndex: tabIndex
  }, /*#__PURE__*/React.createElement(UpwardIcon, {
    className: myStyles.icon
  }))), ' ');
}